import dayjs, { type Dayjs } from "dayjs";
import { formatNumericDate } from "@acto/taskpane/field-sales-2/utils/format";

type Translate = (key: string, values?: Record<string, unknown>) => string;

/**
 * Buckets a past chat's date into a relative label. Buckets are calendar-day differences,
 * so a chat from 23:00 yesterday reads "yesterday", not "today".
 */
export function formatRelativeChatDate(date: Dayjs, t: Translate, locale: string, now: Dayjs = dayjs()): string {
  const daysDiff = now.startOf("day").diff(date.startOf("day"), "day");

  if (daysDiff <= 0) return t("today");
  if (daysDiff === 1) return t("yesterday");
  if (daysDiff <= 6) return t("daysAgo", { days: daysDiff });
  if (daysDiff <= 13) return t("lastWeek");
  return formatNumericDate(date.format("YYYY-MM-DD"), locale);
}
